<template>
  <article>
    <div v-if="title" class="chart-title">
      {{ title }}
    </div>
    <line-chart
      :chart-data="chartData"
      :chart-options="options"
      :plugins="[thresholdPlugin]"
      style="min-height: 360px"
    />
  </article>
</template>

<script>
  import { Line as LineChart } from 'vue-chartjs'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
  } from 'chart.js'

  ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale)

  export default {
    name: 'LoginRateLineChart',
    components: { LineChart },
    props: {
      title: { type: String, default: null },
      labels: { type: Array, default: () => [] },
      datasets: { type: Array, default: () => [] },
      threshold: { type: Number, default: null },
    },
    data () {
      return {
        thresholdPlugin: {
          id: 'rateThreshold',
          afterDraw: (chart) => {
            const t = this.threshold
            if (t === null || t === undefined) return
            const {
              ctx,
              chartArea: { left, right },
              scales: { y },
            } = chart
            const yPos = y.getPixelForValue(t)
            ctx.save()
            ctx.strokeStyle = '#EB5388'
            ctx.setLineDash([6, 4])
            ctx.beginPath()
            ctx.moveTo(left, yPos)
            ctx.lineTo(right, yPos)
            ctx.stroke()
            ctx.restore()
          },
        },
      }
    },
    computed: {
      chartData () {
        return { labels: this.labels, datasets: this.datasets }
      },
      options () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          scales: { x: { grid: { display: false } }, y: { beginAtZero: true } },
          plugins: { legend: { position: 'bottom', labels: { boxWidth: 12 } } },
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.chart-title {
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
